/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GameTrackingHealthStatus = {
    GREEN: 'GREEN',
    YELLOW: 'YELLOW',
    RED: 'RED',
    NO_DATA: 'NO_DATA',
    NOT_EXPECTED: 'NOT_EXPECTED'
} as const;
export type GameTrackingHealthStatus = typeof GameTrackingHealthStatus[keyof typeof GameTrackingHealthStatus];


export function instanceOfGameTrackingHealthStatus(value: any): boolean {
    for (const key in GameTrackingHealthStatus) {
        if (Object.prototype.hasOwnProperty.call(GameTrackingHealthStatus, key)) {
            if (GameTrackingHealthStatus[key as keyof typeof GameTrackingHealthStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GameTrackingHealthStatusFromJSON(json: any): GameTrackingHealthStatus {
    return GameTrackingHealthStatusFromJSONTyped(json, false);
}

export function GameTrackingHealthStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): GameTrackingHealthStatus {
    return json as GameTrackingHealthStatus;
}

export function GameTrackingHealthStatusToJSON(value?: GameTrackingHealthStatus | null): any {
    return value as any;
}

export function GameTrackingHealthStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): GameTrackingHealthStatus {
    return value as GameTrackingHealthStatus;
}

